import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './locales';
import { GlobalProvider } from './contexts/globalContext.js';
import App from './App';
import store from './store.js';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root'));
root.render(
	<Provider store={store}>
		<GlobalProvider>
			<CssBaseline />
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</GlobalProvider>
	</Provider>
);
reportWebVitals();
